<template>
  <v-dialog v-model="dialogProxy" max-width="900px">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-6">
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="search"
              label="Search by name or item number"
              outlined
              @keyup.enter="handleSearch"
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-btn
              color="primary"
              :loading="loading"
              @click="handleSearch"
              :disabled="search.length <= 0"
            >
              Search
            </v-btn>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              color="primary"
              height="40"
              @click="handleReset"
            >
              Reset
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
          class="mt-4"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn color="primary" @click="selectItem(item)">
              Select
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text @click="dialogProxy = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";

const ENDPOINT = "sales/salesOrder/delivery-note/search-items";

export default {
  name: "DeliveryNoteAddItemDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Termék hozzáadása",
    },
  },
  data() {
    return {
      dialogProxy: false,
      search: "",
      loading: false,
      items: [],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "Name", value: "name" },
        { text: "Ref.", value: "reference" },
        { text: "Unit", value: "unit" },
        { text: "Weight", value: "weight" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialogProxy = val;
      },
    },

    dialogProxy(val) {
      this.$emit("input", val);

      if (val) {
        this.searchItems();
      } else {
        this.search = "";
        this.items = [];
        this.totalItems = 0;
        this.options.page = 1;
      }
    },

    options: {
      deep: true,
      handler() {
        if (this.dialogProxy) {
          this.searchItems();
        }
      },
    },
  },
  methods: {
    handleReset() {
        this.search = "";
        this.options.page = 1;
        this.searchItems();
    },

    handleSearch() {
      this.options.page = 1;
      this.searchItems();
    },

    async searchItems() {
      this.loading = true;

      try {
        const query = [
          "q=" + encodeURIComponent(this.search || ""),
          "page=" + encodeURIComponent(this.options.page || 1),
          "per_page=" + encodeURIComponent(this.options.itemsPerPage || 20),
        ].join("&");

        const { data } = await ApiService.get(ENDPOINT, "?" + query);

        this.items = Array.isArray(data.data) ? data.data : [];
        this.totalItems = Number(data.total || 0);

        if (data.current_page) {
          this.options.page = Number(data.current_page);
        }

        if (data.per_page) {
          this.options.itemsPerPage = Number(data.per_page);
        }
      } catch (error) {
        console.error("Item search error", error);
        this.items = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },

    selectItem(item) {
      this.$emit("selected", item);
      this.dialogProxy = false;
    },
  },
};
</script>